{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Excedeu o limite de conversas. O plano Hacker permite apenas 500 conversas.",
      "INBOXES": "Excedeu o limite de caixas de entrada. O plano Hacker só suporta chat ao vivo no site. Caixas de entrada adicionais, como e-mail, WhatsApp, etc., requerem um plano pago.",
      "AGENTS": "Excedeu o limite de agentes. O plano Hacker permite apenas 2 agentes.",
      "NON_ADMIN": "Contacte o seu administrador para atualizar o plano e continuar a utilizar todas as funcionalidades."
    },
    "TITLE": "Configurações da conta",
    "SUBMIT": "Atualizar configurações",
    "BACK": "Voltar",
    "DISMISS": "Descartar",
    "UPDATE": {
      "ERROR": "Não foi possível atualizar as configurações, por favor, tente novamente!",
      "SUCCESS": "Configurações de conta atualizadas com sucesso"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Excluir a sua conta",
      "NOTE": "Depois de excluir a sua conta, todos os seus dados serão eliminados.",
      "BUTTON_TEXT": "Excluir a sua conta",
      "CONFIRM": {
        "TITLE": "Excluir conta",
        "MESSAGE": "Excluir a sua conta é irreversível. Introduza o nome da sua conta abaixo para confirmar que pretende excluí-la permanentemente.",
        "BUTTON_TEXT": "Excluir",
        "DISMISS": "Cancelar",
        "PLACE_HOLDER": "Escreva {accountName} para confirmar"
      },
      "SUCCESS": "Conta marcada para exclusão",
      "FAILURE": "Não foi possível excluir a conta, tente novamente!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Esta conta está agendada para exclusão em {deletionDate}. Isto foi solicitado por um administrador. Pode cancelar a exclusão antes desta data.",
        "MESSAGE_INACTIVITY": "Esta conta está agendada para exclusão em {deletionDate} devido a inatividade. Pode cancelar a exclusão antes desta data.",
        "CLEAR_BUTTON": "Cancelar exclusão agendada"
      }
    },
    "FORM": {
      "ERROR": "Por favor, corrigir erros de formulário",
      "GENERAL_SECTION": {
        "TITLE": "Configurações gerais",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID da conta",
        "NOTE": "Este ID é necessário para integrações via API"
      },
      "NAME": {
        "LABEL": "Nome da conta",
        "PLACEHOLDER": "Nome da sua conta",
        "ERROR": "Por favor, insira um nome de conta válido"
      },
      "LANGUAGE": {
        "LABEL": "Linguagem do site",
        "PLACEHOLDER": "Nome da sua conta",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "E-mail recebido do domínio",
        "PLACEHOLDER": "O domínio onde irá receber os e-mails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail de suporte",
        "PLACEHOLDER": "E-mail de suporte da sua empresa",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Número de dias sem nenhuma atividade, após os quais o ticket se auto-resolve",
        "NOTE": "Número de horas de inatividade após as quais qualquer conversa aberta será resolvida automaticamente.",
        "PLACEHOLDER": "30",
        "ERROR": "Por favor, indique um período de resolução automática válido (mínimo de 1 dia e máximo de 999 dias)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Número de dias após os quais uma conversa vazia se resolve automaticamente, caso não haja atividade",
        "PLACEHOLDER": "nunca",
        "ERROR": "Indique uma duração de resolução automática de conversas vazias válida (mínimo de 1 dia e máximo de 999 dias)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "A sua conta tem a opção de continuar as conversas por e-mail ativa.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Já pode receber e-mails no domínio que escolheu."
      },
      "PHONE": {
        "TITLE": "Configurações do PBX",
        "NOTE": "Configure a ligação ao seu PBX para chamadas telefónicas",
        "SIP_HOST": {
          "LABEL": "Domínio SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Modo de marcação",
          "MODES": {
            "direct": "Direto - a chamada é marcada imediatamente ao clicar na ligação telefónica",
            "indirect": "Indireto - o número de telefone é preparado na caixa de entrada do widget de telefone"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Acesso às gravações de chamadas",
          "MODES": {
            "admin_only": "Apenas administradores",
            "admin_and_assigned_agent": "Administradores e agente responsável",
            "inbox_members": "Todos os agentes com acesso à caixa de entrada"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Configurações de e-mail",
        "NOTE": "Modifica o comportamento das caixas de entrada de e-mail"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Modo de exibição da data/hora da conversa",
        "MODES": {
          "both": "Criação e última atividade",
          "last_activity_only": "Apenas última atividade",
          "last_customer_message": "Última mensagem do cliente"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloquear domínios com reputação baixa"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Incluir a mensagem original na resposta ao e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Resolver automaticamente uma nova conversa"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Mover automaticamente uma nova conversa de e-mail para a caixa de entrada do robô que processou as encomendas do contacto"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etiquetas alargadas - Permite nomes de etiquetas mais longos com uma interface de popup maior"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Atribui automaticamente a conversa ao agente que criou a última resposta"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modo de notificações Push",
        "MODES": {
          "all_inboxes": "Todas as caixas de entrada - Envia notificações para todos os tipos de canal",
          "chat_only": "Apenas chat - Envia notificações apenas para canais que não sejam de e-mail"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Permitir ativar/desativar a assinatura nas mensagens enviadas"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Mostrar o estado de chat do agente no wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Mostrar os nomes completos dos anexos sem os truncar"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Início de sessão com palavra-passe",
        "MODES": {
          "allowed_for_all": "Permitido para todos os utilizadores",
          "allowed_for_agents_only": "Permitido apenas para agentes (os administradores devem utilizar OAuth)",
          "password_login_disabled": "Desativado - apenas OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Está disponível uma nova versão. Recarregue para obter as atualizações mais recentes.",
    "RELOAD_NOW": "Atualizar agora",
    "LEARN_MORE": "Saber mais",
    "PAYMENT_PENDING": "O seu pagamento está pendente. Por favor, atualize as suas informações de pagamento para continuar a usar este software",
    "LIMITS_UPGRADE": "A sua conta excedeu os limites de utilização. Por favor, faça um upgrade ao seu plano para continuar a utilizar este software",
    "OPEN_BILLING": "Abrir faturação"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Pressione Enter para escolher",
      "ENTER_TO_REMOVE": "Pressione Enter para eliminar",
      "NO_OPTIONS": "A lista está vazia",
      "NO_RESULT": "Nenhum resultado encontrado",
      "SELECT_ONE": "Selecionar um",
      "SELECT": "Selecionar"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notificações",
    "MARK_ALL_DONE": "Marcar todos como resolvidos",
    "DELETE_TITLE": "Excluído",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notificações não lidas",
      "ALL_NOTIFICATIONS": "Ver todas as notificações",
      "LOADING_UNREAD_MESSAGE": "A carregar notificações não lidas...",
      "EMPTY_MESSAGE": "Não há notificações não lidas"
    },
    "LIST": {
      "LOADING_MESSAGE": "A carregar notificações...",
      "404": "Sem notificações",
      "TABLE_HEADER": [
        "Nome",
        "Número de telefone",
        "Conversas",
        "Último contacto"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nova conversa",
      "conversation_assignment": "Conversa atribuída",
      "assigned_conversation_new_message": "Nova mensagem",
      "participating_conversation_new_message": "Nova mensagem",
      "conversation_mention": "Mencionar",
      "sla_missed_first_response": "SLA perdido",
      "sla_missed_next_response": "SLA perdido",
      "sla_missed_resolution": "SLA perdido"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Ausente",
      "RECONNECTING": "A reconectar...",
      "RECONNECT_SUCCESS": "Reconectado"
    },
    "BUTTON": {
      "REFRESH": "Atualizar"
    },
    "CONNECTION_LOST": {
      "TITLE": "Ligação perdida",
      "DESCRIPTION": "Não foi possível contactar o servidor. Verifique a sua ligação e tente novamente.",
      "RETRY": "Tentar novamente"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Pesquisar ou passar para",
    "SECTIONS": {
      "GENERAL": "Geral",
      "REPORTS": "Relatórios",
      "CONVERSATION": "Conversa",
      "BULK_ACTIONS": "Ações em massa",
      "CHANGE_ASSIGNEE": "Alterar responsável",
      "CHANGE_PRIORITY": "Alterar prioridade",
      "CHANGE_TEAM": "Alterar equipa",
      "SNOOZE_CONVERSATION": "Adiar conversa",
      "EXECUTE_MACRO": "Executar macro",
      "ADD_LABEL": "Adicionar etiqueta à conversa",
      "REMOVE_LABEL": "Remover etiqueta da conversa",
      "SETTINGS": "Configurações",
      "AI_ASSIST": "Assistente IA",
      "APPEARANCE": "Aparência",
      "SNOOZE_NOTIFICATION": "Suspender notificação"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Ir para o painel de conversação",
      "GO_TO_CONTACTS_DASHBOARD": "Ir para o painel de contactos",
      "GO_TO_REPORTS_OVERVIEW": "Ir para a visão geral de relatórios",
      "GO_TO_CONVERSATION_REPORTS": "Ir para relatórios de conversa",
      "GO_TO_AGENT_REPORTS": "Ir para relatórios de agentes",
      "GO_TO_LABEL_REPORTS": "Ir para relatórios de etiquetas",
      "GO_TO_INBOX_REPORTS": "Ir para relatórios da caixa de entrada",
      "GO_TO_TEAM_REPORTS": "Ir para relatórios da equipa",
      "GO_TO_SETTINGS_AGENTS": "Ir para configurações do agente",
      "GO_TO_SETTINGS_TEAMS": "Ir para configurações da equipa",
      "GO_TO_SETTINGS_INBOXES": "Ir para configurações da caixa de entrada",
      "GO_TO_SETTINGS_LABELS": "Ir para configurações de etiquetas",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Ir para configurações de resposta pronta",
      "GO_TO_SETTINGS_APPLICATIONS": "Ir para configurações da aplicação",
      "GO_TO_SETTINGS_ACCOUNT": "Ir para configurações da conta",
      "GO_TO_SETTINGS_PROFILE": "Ir para configurações do perfil",
      "GO_TO_NOTIFICATIONS": "Ir para notificações",
      "ADD_LABELS_TO_CONVERSATION": "Adicionar etiqueta à conversa",
      "ASSIGN_AN_AGENT": "Atribuir um agente",
      "AI_ASSIST": "Assistente IA",
      "ASSIGN_PRIORITY": "Atribuir prioridade",
      "ASSIGN_A_TEAM": "Atribuir uma equipa",
      "EXECUTE_A_MACRO": "Executar uma macro",
      "MUTE_CONVERSATION": "Silenciar conversa",
      "UNMUTE_CONVERSATION": "Reativar conversa",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remover etiqueta da conversa",
      "REOPEN_CONVERSATION": "Reabrir conversa",
      "RESOLVE_CONVERSATION": "Resolver conversa",
      "SEND_TRANSCRIPT": "Enviar transcrição por e-mail",
      "SNOOZE_CONVERSATION": "Adiar conversa",
      "UNTIL_NEXT_REPLY": "Até à próxima resposta",
      "UNTIL_NEXT_WEEK": "Até à próxima semana",
      "UNTIL_TOMORROW": "Até amanhã",
      "UNTIL_NEXT_MONTH": "Até ao mês seguinte",
      "AN_HOUR_FROM_NOW": "Até daqui a uma hora",
      "UNTIL_CUSTOM_TIME": "Personalizar...",
      "CHANGE_APPEARANCE": "Alterar aparência",
      "LIGHT_MODE": "Claro",
      "DARK_MODE": "Escuro",
      "SYSTEM_MODE": "Sistema",
      "SNOOZE_NOTIFICATION": "Suspender notificação"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "A carregar app do dashboard..."
  },
  "COMMON": {
    "OR": "Ou",
    "CLICK_HERE": "clique aqui"
  }
}
